<template>
  <div class="fullcars"> 
    <template>
      <v-container class="grey lighten-5">
        <v-row >
          <v-col cols="12" sm="12" md="12" lg="12" xl="12">
            <h5>Buscar:</h5>
            <input type="text" placeholder="Escribe un chasis" v-model="sword" v-on:keyup.13="getBreadcrumps(sword)">
            <h5>Subir Archivo:</h5>
            <!-- <input type="file"> -->
            <!-- <v-file-upload density="default"></v-file-upload> -->
            <v-file-input v-model="sfiles" id='file' label="Subir archivo xls" @change="upFileXls()"></v-file-input>
            

          </v-col>              
        </v-row>            
      </v-container>
    </template>

    <!-- table Excel -->
  <template v-if="items.length > 0">
    <v-simple-table
      fixed-header
      dense
    >
      <template v-slot:default>
        <thead>
          <tr><th class="text-left" v-for="thead in theaderExcel" :key="thead.id">{{thead.text}}</th></tr>
        </thead>
        <tbody>
          <!-- v-for="row in subfamilies" -->
          <tr v-for="(item) of items" :key="item.id" >
            <td v-for="(ritem) of item" :key="ritem.id" >
              {{ ritem }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </template>
<!-- FIN table Excel -->    



    <v-card
        flat
        class="py-12"
      >
        <v-card-text >
          <v-row class="text-right" justify="center" >        
            <v-btn-toggle
              v-model="toggle_exclusive"
              mandatory
            >
        <!-- Nuevo Registro SubFamily -->                       
            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">    
                    <v-btn                  
                      color="green"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog=true"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Nuevo Auto</span>
                </v-tooltip>
            </template>         
        <!-- FIN Nuevo Registro SubFamily -->   
         <!-- Subir Archivo Excel -->
            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }"> 
                    <v-btn                  
                      color="default"
                      v-bind="attrs"
                      v-on="on"
                      @click="upFileXls()"
                    >
                      <v-icon>upload</v-icon>
                    </v-btn>
                  </template>
                  <span>Subir Archivo Excel</span>
                </v-tooltip>
            </template>         
        <!-- FIN Subir Archivo Excel -->
                
        <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">              
                    <v-btn
                      @click="getBrand('')" 
                      color="primary darken-5"               
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                    <v-icon>refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Refrescar Página</span>
                </v-tooltip>
        </template>
            
                      
            <template>  
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">              
                    <v-btn
                      @click="$router.back()" 
                      color="primary darken-2"               
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                    <v-icon>arrow_back</v-icon>
                    </v-btn>
                  </template>
                  <span>Regresar a la Página Anterior</span>
                </v-tooltip>
            </template>
              
              
            </v-btn-toggle>
          </v-row>
      </v-card-text>
    </v-card>

<!-- table -->
  <template>
    <!-- height="700px" -->
    <v-simple-table
      fixed-header
      dense
    >
      <template v-slot:default>
        <thead>
          <tr><th class="text-left" v-for="thead in theader" :key="thead.id">{{thead.text}}</th></tr>
        </thead>
        <tbody>
          <!-- v-for="row in subfamilies" -->
          <tr
            v-for="(row,index) of fullcars" :key="row.id"
          >
              <td>
              <!-- 
              <button v-on:click="deleteFriend(row.id, i)">x</button>
              -->
              <v-btn v-on:click="editRow = row.id" icon>
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn 
                v-on:click="getFullCar2(row.id)"
                icon
              >
                <v-icon>add_photo_alternate</v-icon>
              </v-btn>              
              <v-btn 
                v-on:click="getProduct(row.id)"
                icon
              >
                <v-icon>visibility</v-icon>
              </v-btn>    
                  <!-- Add Woo -->
                  <v-btn
                          v-if='row.woo == 0'
                          v-on:click="upProductWoo(row.id)"
                          color="deep-purple default"
                          v-bind="attrs"
                          v-on="on"
                        >                
                          <!-- v-on:click="pricechangeWoo(pricelist.id)"  -->
                          <v-icon>publish</v-icon>
                  </v-btn>    
                  <!-- Add FIN Woo -->                     
            </td>   
            <td>
              <div v-if="editRow === row.id">      
                <br>
                <v-text-field
                              v-model="row.chasis"
                              v-on:keyup.13="updateRow(row)"
                              label="Chasis"
                />
                <v-autocomplete
                    v-model="row.brand_id"
                    :hint="`${id} - ${catbrands.name}`"
                    :items="catbrands"
                    item-text="name"
                    item-value="id"
                    label="Selecciona una Marca"  
                    outlined
                ></v-autocomplete>
                <v-autocomplete
                    v-model="row.catcarmodel_id"
                    :hint="`${catcarmodels.id} - ${catcarmodels.name}`"
                    :items="catcarmodels"
                    item-text="name"
                    item-value="id"
                    label="Selecciona una Marca"  
                    outlined
                ></v-autocomplete>
                <v-autocomplete
                    v-model="row.catcarversion_id"
                    :hint="`${catcarversions.id} - ${catcarversions.name}`"
                    :items="catcarversions"
                    item-text="name"
                    item-value="id"
                    label="Selecciona una Version"  
                    outlined
                ></v-autocomplete>
                
                  <v-text-field
                              v-model="row.transmision"
                              v-on:keyup.13="updateRow(row)"
                              label="Transmision"
                />
                  <v-text-field
                              v-model="row.color_ext"
                              v-on:keyup.13="updateRow(row)"
                              label="Color"
                />
                  <v-text-field
                              v-model="row.year"
                              v-on:keyup.13="updateRow(row)"
                              label="Año"
                />
                  <v-text-field
                              v-model="row.km"
                              v-on:keyup.13="updateRow(row)"
                              label="km"
                />
                  <v-text-field
                              v-model="row.price"
                              v-on:keyup.13="updateRow(row)"
                              label="Precio"
                />
                  <v-text-field
                              v-model="row.notes"
                              v-on:keyup.13="updateRow(row)"
                              label="Notes"
                />

                <v-btn v-on:click="updateRow(row)" class="green">Actualizar</v-btn>
                <v-btn v-on:click="editRow=false;" class="default">Cerrar</v-btn>
              </div>
              <div v-else>  
                {{ index+1 }}
              </div>        
            </td>            
            <td>{{ row.chasis }}</td>
            <td>{{ row.brand_name }}</td>
            <td>{{ row.model_name }}</td>
            <td>{{ row.version_name }}</td>
            <td>{{ row.transmision }}</td>
            <td>{{ row.color_ext }}</td>
            <td>{{ row.year }}</td>
            <td>{{ row.km }}</td>
            <td>{{ row.price }}</td>
            <td>
              <div v-if="row.notes != null && row.notes != ''">   
                  <v-btn
                    color="red lighten-2"
                    dark
                    @click="getNote(row.notes)" 
                  >
                    ver nota
                  </v-btn>
              </div>        
          </td>        
            <td>
              <div v-if="row.ver == '1'">        
                <v-chip
                class="ma-2"
                color="green"
                label
                text-color="white"
                >
                  <v-icon left>
                    mdi-label
                  </v-icon>
                  Activo
                </v-chip>
              </div>                 
              <div v-else>
                <v-chip
                class="ma-2"
                color="default"
                label
                text-color="white"
                >
                  <v-icon left>
                    mdi-label
                  </v-icon>
                  Desactivado
                </v-chip>
              </div>                                                                       
            </td>            
            <td>{{formatDate(row.updated_at)}}</td>     
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </template>
<!-- FIN table -->

<!-- Dialog Brand Create -->
<v-dialog
      v-model="dialog"
      persistent
      max-width="600px"
    >      
      <v-card>
        <v-card-title>
          <span class="headline">Nuevo Auto</span>
          <v-btn
            class="headline"
            color="blue darken-1"
            text
            @click="dialog = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <EventForm :submitForm="AddCar" buttonText="Guardar" hasCar=true />            
               <!-- <v-text-field
                  v-model="salesorder_id"
                  label="Venta ID*"
                  required
                ></v-text-field> -->              
          </v-container>          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <small style="color:red;">*Campos Obligatorios</small>          
          <!-- <v-btn 
            color="blue darken-1"
            text
            v-on:click="submit">Guardar <v-icon>save</v-icon>
          </v-btn>         -->
        </v-card-actions>
      </v-card>
</v-dialog>
<!-- Dialog Brand Create -->

<!-- Dialog Picture Create -->
<v-dialog
      v-model="dialogPicture"
      persistent
      max-width="600px"
    >      
      <v-card>
        <v-card-title>
          <span class="headline">Nueva Imagen</span>
          <v-btn
            class="headline"
            color="blue darken-1"
            text
            @click="dialogPicture = false"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
            <!-- importante el v-if para que destruya el componente -->
            <v-container v-if='this.dialogPicture==true'>
            <!-- <PictureForm :submitForm="AddPicture" buttonText="Guardar" hasCar=true />             -->
            <!-- <PictureForm  buttonText="Guardar" hasCar=true />             -->
            <PictureCreate :hasValorID="hasValorID" />            
          </v-container>          
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <small style="color:red;">*Campos Obligatorios</small>          
          <!-- <v-btn 
            color="blue darken-1"
            text
            v-on:click="submit">Guardar <v-icon>save</v-icon>
          </v-btn>         -->
        </v-card-actions>
      </v-card>
</v-dialog>
<!-- Dialog Picture Create -->

<!-- VISTA PRODUCTO DIALOG-->
      <template>                 
                      <v-dialog
                        v-model="dialogViewProduct"
                        persistent
                        max-width="75%"                 
                      >
                          <v-card>
                            <v-card-title>
                              <span class="headline">Detalle Auto</span>
                              <v-btn
                                class="headline"
                                color="blue darken-1"
                                text
                                @click="dialogViewProduct = false"
                              >
                                <v-icon>close</v-icon>
                              </v-btn>
                            </v-card-title>
                            <v-container v-if='this.dialogViewProduct==true'>
                                <FullCarView :productid="productid"  />
                            </v-container>
                            <!-- :pricelist="priceslist -->
                            <!-- buttonText="Guardar"   -->
                          <v-card-actions>
                              <v-btn 
                              
                              color="red" 
                              @click="dialogViewProduct = false"
                              >
                              cerrar
                            </v-btn>
                              <v-spacer></v-spacer>              
                            </v-card-actions>
                          </v-card>                    
                      </v-dialog>
      </template>                 
      <!-- FIN VISTA PRODUCTO  DIALOG-->

<!-- DIALOG NOTAS -->
<div class="text-center">
            <v-dialog
              v-model="dialogNotes"
              width="30%"
            >
              <v-card>
                <v-card-title class="headline grey lighten-2">
                  Notas
                </v-card-title>
                <v-card-text class="my-5">
                  {{notes}}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    text
                    @click="dialogNotes = false"
                  >
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
</div>
<!-- FIN DIALOG NOTAS -->



  </div>
</template>




<script>
// import axios from "axios";
import{ mapMutations, mapState } from "vuex";
//import FieldSearch from '@/components/FieldSearch.vue'
// import baseApi from '@/services/baseApi';
import icheckApi from '@/services/icheckApi';
import EventForm from "@/components/CarAutoCreate";
import PictureCreate from "@/components/PictureCreate";
import FullCarView from "@/components/FullCarView";
// import { VFileUpload } from '@/vuetify/labs/VFileUpload'


// import EventForm from "@/components/CarAutoCreate";
import Dayjs from 'dayjs';
import es from "dayjs/locale/es";
import readXlsFile from "read-excel-file";

export default {
  name: 'fullcars',
  computed:{
        ...mapState(['fullcars','catbrands','catcarmodels','catcarversions'])
  },
  components: {
      //FieldSearch,
    EventForm,
    FullCarView,
    PictureCreate,
    // VFileUpload
  },
  methods:{
      ...mapMutations(["showLoading","hiddenLoading","changeBreadcrumbs"]),
      formatDate(dateString) {
            Dayjs.locale(es)
            const date = Dayjs(dateString);
            return date.format('dddd MMMM D, YYYY')
      },  
      upFileXls(){
        console.log('Upload File');
        const input= document.getElementById('file');
        readXlsFile(input.files[0]).then((rows) =>{
        // readXlsFile(this.sfiles.files[0]).then((rows) =>{
          this.items=rows;
        });
        // console.log('Row '+this.items);

      },
      getNote(note){
        // console.log('Producto ID:'+ProductID);
        this.notes=note;
        // alert(this.hasValorID);
        this.dialogNotes =true;  
      },
      async getProduct(ProductID){
        console.log('Producto ID:'+ProductID);
        this.productid=ProductID;
        //alert(this.productid);
        this.dialogViewProduct=true;      
      },
      async getFullCar2(ProductID){
        console.log('Producto ID: '+ProductID);
        this.hasValorID=ProductID;
        //alert(this.hasValorID);
        this.dialogPicture=true;      
      },        
      async getFullCar(sword){       
        this.attribute.sword=sword;
        try{
          this.showLoading({titulo:"Accediendo información",color:"primary"})
          this.$store.dispatch('loadFullCars',this.attribute);          
          this.attribute.sword="All";
        }catch(error){
          //console.log(error);
          this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
        }  finally{
          this.hiddenLoading()
        } 
      },  
      async getCatBrand(){
          this.attribute.sword='';
          try{        
            this.showLoading({titulo:"Accediendo información",color:"primary"})
            this.$store.dispatch('loadCatBrands',this.attribute);
          }catch(error){
            //console.log(error);
            this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
          } finally{
            this.hiddenLoading()
          }                     
      }, 
       async getCatCarModel(){
          this.attribute.sword='';
          try{        
            this.showLoading({titulo:"Accediendo información",color:"primary"})
            this.$store.dispatch('loadCatCarModels',this.attribute);
          }catch(error){
            //console.log(error);
            this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
          } finally{
            this.hiddenLoading()
          }                     
      }, 
      async getCatCarVersion(){
          this.attribute.sword='';
          try{        
            this.showLoading({titulo:"Accediendo información",color:"primary"})
            this.$store.dispatch('loadCatCarVersions',this.attribute);
          }catch(error){
            //console.log(error);
            this.$swal("Error!", "Necesita ingresar sus credenciales", "error");
          } finally{
            this.hiddenLoading()
          }                     
      }, 
      async getBreadcrumps(sword){       
        this.getFullCar(sword);
        this.getCatBrand();
        this.getCatCarModel();
        this.getCatCarVersion();
      },         
      // async AddPicture(BrandInfo){
      async AddPicture(){
        // alert("Agregar Evento");
        // alert ('test '+BrandInfo.name);
        alert ('test ');
        try{ 
          this.showLoading({titulo:"Almacenando información",color:"warning"})
          // let name=BrandInfo.name;
          // let notes=BrandInfo.notes;
          // let filename='';
          // const { salesorder_id,customer_id,fecha_inicio,cantidad } = this;        
          //let datos=await baseApi().post();          
          // await icheckApi().post(`/autos`,JSON.stringify({ name,notes,filename })).then((response)=>{
          //     if(!response.data.error){                            
          //       // this.$swal("Genial!","", "success");
          //       this.$swal("Genial!",response.data.message, "success");
          //     }else{
          //       this.$swal("Error!",response.data.message, "error");
          //     }                                    
          //     // console.log("VENTA: "+response.data.message);
          // });
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", "Se agregó la información", "success");
        } 
      },       
       async AddCar(BrandInfo){
        // alert("Agregar Evento");
        // alert ('test '+BrandInfo.name);
        alert ('test ');
        try{ 
          this.showLoading({titulo:"Almacenando información",color:"warning"})
          let name=BrandInfo.name;
          let notes=BrandInfo.notes;
          let filename='';
          // const { salesorder_id,customer_id,fecha_inicio,cantidad } = this;        
          // let datos=await baseApi().post();          
          await icheckApi().post(`/autos`,JSON.stringify({ name,notes,filename })).then((response)=>{
              if(!response.data.error){                            
                this.$swal("Genial!",response.data.message, "success");
              }else{
                this.$swal("Error!",response.data.message, "error");
              }                                    
          });
        }catch(error){
          //console.log(error);
        }  finally{
          this.hiddenLoading()
          // this.$swal("Genial!", "Se agregó la información", "success");
        } 
      },  
      async upProductWoo(id){
          try{        
            //console.log(this.sword2);       
            this.showLoading({titulo:"Creado el producto en Woocommerce",color:"default"})
            
            await icheckApi().get('/woo/products/create/'+id).then((response)=>{  
              if(!response.data.error){                            
                  this.$swal("Genial!",response.data.message, "success");
                }else{
                  this.$swal("Error!",response.data.message, "error");
                }                                          
            });          
          }catch(error){
            //console.log(error);
          }  finally{
            this.hiddenLoading()
            // this.$swal("Genial!", this.rdesc, this.rtitle);
          } 
      },
      async setDataProductWoo(priceid) {               
            try{        
            //console.log(this.sword2);       
            this.showLoading({titulo:"Crear registro de Woo",color:"blue"})
            
            await icheckApi().get('/precios/wooaddone/'+priceid).then((response)=>{  
              if(!response.data.error){                            
                  this.$swal("Genial!",response.data.message, "success");
                }else{
                  this.$swal("Error!",response.data.message, "error");
                }                                          
            });          
          }catch(error){
            //console.log(error);
          }  finally{
            this.hiddenLoading()
            // this.$swal("Genial!", this.rdesc, this.rtitle);
          } 

      },
      updateRow(row) {      
        try{        
            this.showLoading({titulo:"Accediendo información",color:"warning"})        
            icheckApi().post(`/autos/update/${row.id}`,JSON.stringify(row)).then((response)=>{
                if(!response.data.error){                            
                  // this.$swal("Genial!","", "success");
                  this.$swal("Genial!",response.data.message, "success");
                }else{
                  this.$swal("Error!",response.data.message, "error");
                }                                    
                // console.log("VENTA: "+response.data.message);
            });                                                                                                    
            // console.log(datos);
          }catch(error){
            console.log(error);
          }  finally{
            this.hiddenLoading()
            // this.$swal("Genial!", "Se actualizó la información", "success");
          } 
      },
  },
  data(){
    return{
      items:[],
      attribute: {sword: '',limit: 500},
      dialog:false,
      dialogPicture:false,
      dialogViewProduct:false,
      dialogNotes:false,
      hasValorID:'',
      toggle_exclusive:'',
      sword:"",     
      sfiles:'',
      notes:'',
      editRow:null,
      itemsStatus:[        
          'Proceso',
          'Contactado',
          'No Responde',
          'Finalizado'
      ],      
      theader: [
          { text: 'Acción', value: 'canasta_basica' },
          { text: '#', value: 'index' },
          { text: 'Chasis', value: 'index' },
          { text: 'Marca', value: 'index' },
          { text: 'Modelo', value: 'index' },
          { text: 'Version', value: 'index' },
          { text: 'Transmision', value: 'notes' },
          { text: 'Color Exterior', value: 'notes' },
          { text: 'Año', value: 'notes' },
          { text: 'km', value: 'notes' },
          { text: 'precio', value: 'notes' },
          { text: 'Notas', value: 'notes' },
          { text: 'Status', value: 'created_at' },        
          { text: 'Actualización', value: 'updated_at' },        
      ],
      theaderExcel: [
          { text: 'Acción', value: 'canasta_basica' },
          { text: '#', value: 'index' },
          { text: 'Chasis', value: 'index' },
          { text: 'Marca', value: 'index' },
          { text: 'Modelo', value: 'index' },
          { text: 'Version', value: 'index' },
          { text: 'Transmision', value: 'notes' },
          { text: 'Color Exterior', value: 'notes' },
          { text: 'Año', value: 'notes' },
          { text: 'km', value: 'notes' },
          { text: 'precio', value: 'notes' }
      ],
    }
  }, 
  created(){
    this.changeBreadcrumbs({
          page:"Autos",
          title:"Lista de Autos",
          subtitle:"primary",
          description:"En esta lista encontrará todas los autos dadas de alta en el sistema desde el principio de los tiempos"
    });
    this.getBreadcrumps(this.sword)    
  }
}
</script>